import { useLazyQuery } from "@apollo/client";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import {
  AtsJunctionsEdge,
  AtsJunctionsOrderField,
  GetTransformNearByJunctionsResult,
  GetTransformNearByJunctionsVar,
} from "./queries/types";
import { GetTransformNearByJunctions } from "./queries/queries";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../context/context";
import { OrderDirection } from "../../../utils/commonQueryTypes";
import {
  DEFAULT_LATITUDE,
  DEFAULT_LONGIYUDE,
  TicketStatus,
} from "../../../utils/constants";
import { CustomTooltip } from "../../../styles/TooltipStyles";
import { TOOLTIP_COLORS } from "../../../styles/Variables";
import { CustomDrawerInMobile } from "../../../styles/CustomDrawerStyles";
import FollowUpStatus from "./FollowUpStatus";
import RaiseTicket from "./RaiseTicket";
import { payloadTypes } from "../../../context/reducer";
import Loading from "../../../images/Loading.gif";

type Tree = {
  key: string;
  name: string;
  lat: number;
  lng: number;
};

export default function MobileMap() {
  const { state, dispatch } = useContext(AppContext);
  const [viewTicketDatails, setViewTicketDatails] = useState(false);
  const [raiseTicketDatails, setRaiseTicketDatails] = useState(false);

  const [getTransformNearByJunctions, { data, loading }] = useLazyQuery<
    GetTransformNearByJunctionsResult,
    GetTransformNearByJunctionsVar
  >(GetTransformNearByJunctions);

  useEffect(() => {
    if (state.longitude && state.latitude) {
      getTransformNearByJunctions({
        variables: {
          longitude: state.longitude,
          latitude: state.latitude,
          after: null,
          first: 25,
          orderBy: {
            direction: OrderDirection.DESC,
            field: AtsJunctionsOrderField.NAME,
          },
          name: "",
        },
      });
    }
  }, [getTransformNearByJunctions, state.longitude, state.latitude]);

  let defaultCenter = {
    lat: state.latitude ? state.latitude : DEFAULT_LATITUDE,
    lng: state.longitude ? state.longitude : DEFAULT_LONGIYUDE,
  };

  const Markers = () => {
    return (
      <>
        {data &&
          data.GetTransformNearByJunctions.edges.map(({ node }, key) => {
            const {
              latitude,
              longitude,
              id,
              icon,
              companyID,
              ticketStatus,
              name,
            } = node;
            const itemPoint: Tree = {
              key: JSON.stringify({
                id,
                latitude,
                longitude,
              }),
              lat: Number(latitude),
              lng: Number(longitude),
              name: id.toString(),
            };

            const img = require(`${
              process.env.React_App_Display_Transform_Map_Icons
            }/${icon ? icon : "item"}.svg`);

            return (
              <AdvancedMarker
                key={key}
                position={itemPoint}
                zIndex={ticketStatus === TicketStatus.OPEN ? 4 : 1}
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_JUNCTION_ID,
                    payload: {
                      junctionID: id,
                    },
                  });
                  dispatch({
                    type: payloadTypes.SET_COMPANY_ID,
                    payload: {
                      companyId: companyID,
                    },
                  });
                  if (ticketStatus === TicketStatus.CLOSED) {
                    setRaiseTicketDatails(true);
                  } else {
                    setViewTicketDatails(true);
                  }
                }}
                className={`marker feature status__${ticketStatus.toLocaleLowerCase()}`}
              >
                <CustomTooltip
                  title={<>{name}</>}
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: TOOLTIP_COLORS.VARIABLE,
                        "& .MuiTooltip-arrow": {
                          color: TOOLTIP_COLORS.VARIABLE,
                        },
                      },
                    },
                  }}
                >
                  <img
                    src={img}
                    className={`marker-img .status__${ticketStatus.toLocaleLowerCase()}`}
                    alt="Image not found"
                  />
                </CustomTooltip>

                <div
                  className={`tip status__${ticketStatus.toLocaleLowerCase()}`}
                ></div>
              </AdvancedMarker>
            );
          })}
      </>
    );
  };

  return (
    <>
      {loading ? (
        <div className="loading-container">
          <img src={Loading} alt="loading" className="loading-gif" />
        </div>
      ) : (
        <APIProvider
          apiKey={
            process.env.React_App_MAP ? process.env.React_App_MAP : "token"
          }
        >
          <div className="map-view">
            <Map
              defaultZoom={13}
              defaultCenter={defaultCenter}
              mapId={
                process.env.React_App_Map_ID
                  ? process.env.React_App_Map_ID
                  : "token"
              }
              disableDefaultUI={true}
              gestureHandling={"greedy"}
            >
              <Markers />
            </Map>
          </div>
        </APIProvider>
      )}

      <CustomDrawerInMobile
        anchor="bottom"
        open={viewTicketDatails}
        onClose={() => setViewTicketDatails(!viewTicketDatails)}
      >
        <FollowUpStatus setModal={setViewTicketDatails} />
      </CustomDrawerInMobile>
      <CustomDrawerInMobile
        anchor="bottom"
        open={raiseTicketDatails}
        onClose={() => setRaiseTicketDatails(!raiseTicketDatails)}
      >
        <RaiseTicket setModal={setRaiseTicketDatails} />
      </CustomDrawerInMobile>
    </>
  );
}
